import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const SIGNED_STATUSES = ['SIGNED', 'SIGNED_FULL']

function sortSignersByValidatorFirst(documentSigners) {
  return documentSigners.slice().sort((documentSignerA, documentSignerB) => {
    if (documentSignerA.validator && !documentSignerB.validator) return -1
    if (!documentSignerA.validator && documentSignerB.validator) return 1
    return 0
  })
}

export default function useDocumentSign(documentSign) {
  const { t } = useI18n()

  const orderedSigners = computed(() => {
    return sortSignersByValidatorFirst(documentSign.documentSigners)
  })

  const signersWhoCanSign = computed(() => {
    const documentSigners = orderedSigners.value
    let canSign = []

    const validators = documentSigners.filter((signer) => signer.validator)
    const nonValidators = documentSigners.filter((signer) => !signer.validator)

    validators.forEach((documentSigner, index) => {
      if (index === 0) {
        if (!isSignerAlreadySigned(documentSigner)) {
          canSign = [...canSign, documentSigner.id]
        }
      } else {
        const previousValidatorStatus = validators[index - 1]
        if (isSignerAlreadySigned(previousValidatorStatus) && !isSignerAlreadySigned(documentSigner)) {
          canSign = [...canSign, documentSigner.id]
        }
      }
    })

    const allValidatorsSigned = validators.every((vStatus) => isSignerAlreadySigned(vStatus))
    nonValidators.forEach((documentSigner) => {
      if (allValidatorsSigned && !isSignerAlreadySigned(documentSigner)) {
        canSign = [...canSign, documentSigner.id]
      }
    })

    return canSign
  })

  function getDocumentSignerTypeLabel(documentSigner) {
    return t(`document.documentSigner.signType.${documentSigner.signType}`)
  }

  function isSignerAlreadySigned(documentSigner) {
    return documentSigner.documentSignFileStatuses.some((documentSignFileStatus) =>
      SIGNED_STATUSES.includes(documentSignFileStatus.status),
    )
  }

  function getSignUrl(documentSigner) {
    const params = new URLSearchParams({
      token: documentSigner.token,
      validation: documentSigner.validator ? '1' : '0',
    })
    return `/sign/${documentSigner.id}?${params.toString()}`
  }

  return {
    orderedSigners,
    getDocumentSignerTypeLabel,
    signersWhoCanSign,
    isSignerAlreadySigned,
    getSignUrl,
  }
}
